export default __webpack_public_path__ + "static/media/sel_knol.bde2ef1a.svg";